
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'AcuteMyeloidLeukemia',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Hema/AcuteMyeloidLeukemia.vue